export const notificationTypes = {
    ADD_NEW_NOTIFICATIONS: 'ADD_NEW_NOTIFICATIONS',
    NOTIFICATION_REQUEST: 'NOTIFICATION_REQUEST',
    NOTIFICATION_SUCCESS: 'NOTIFICATION_SUCCESS',
    NOTIFICATION_FAILURE: 'NOTIFICATION_FAILURE',
    NOTIFICATION_RECEIVED: 'NOTIFICATION_RECEIVED',
    NOTIFICATION_RULE_DELETED: 'NOTIFICATION_RULE_DELETED',
    NOTIFICATION_ARCHIVED: 'NOTIFICATION_ARCHIVED',
}
